module.exports = __webpack_public_path__ + "img/photo-1.63d3e5b7.jpg";